module.exports = __webpack_public_path__ + "img/draggable.e943439a.svg";